import localeStore from '@app/src/common/store/LocaleStore';

const WARNING_WIDGET_TRANSLATION_ID = 'general.header.warning';

export const getHighRestrictedDataMessage = () => {
  const warningWidgetMessage = localeStore.formatMessage(
    WARNING_WIDGET_TRANSLATION_ID
  );

  return warningWidgetMessage === WARNING_WIDGET_TRANSLATION_ID
    ? ''
    : warningWidgetMessage;
};

export const getDownloadedFileNameWithRestrictedMessage = (
  fileTitle: string
) => {
  const restrictedDataMessage = getHighRestrictedDataMessage();

  return restrictedDataMessage
    ? `(${restrictedDataMessage}) - ${fileTitle}`
    : fileTitle;
};
